import { z } from "zod/v4";

export const NotificationDataSchema = z.object({
  type: z.enum(["alarm_activation"]),
  tenantId: z.string().optional(),
  siteId: z.string().optional(),
  cameraKey: z.string().optional(),
});

export type NotificationData = z.infer<typeof NotificationDataSchema>;

export type PermissionStatus = "granted" | "denied" | "undetermined";

export type PushNotificationStatus = {
  permission: PermissionStatus;
  registered: boolean;
};
